import React from 'react';
import { withStyles } from "tss-react/mui";
import withMediaQuery from 'components/WithMediaQuery';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';

import DropDown from 'components/DropDown';
import ResponsiveDialogHeader from 'components/ResponsiveDialogHeader';
import DialogTransition from 'components/DialogTransition';
import PrimaryDialogButton from 'components/PrimaryDialogButton';
import SecondaryDialogButton from 'components/SecondaryDialogButton';

import isStringSet from 'utilities/is/isStringSet';
import styles from './styles';

import m from 'messages';

class DenySwipeDialog extends React.Component {

    state = {
        denyReasonID: ''
    };

    onDeny = () => {
        const denyReason = this.props.denyReasons.filter(r => r.reasonID === this.state.denyReasonID);
        if (denyReason && denyReason.length === 1) {
            this.props.onDenySwipe(denyReason[0]);
        }
    };

    canSave = () => isStringSet(this.state.denyReasonID);

    handleReasonChange = (event) => {
        this.setState({ denyReasonID: event.target.value });
    };

    render() {
        const { classes, fullScreen } = this.props;

        const reasonMap = {};
        this.props.denyReasons.map(reason => reasonMap[reason.reasonID] = reason.reasonDescription);

        const renderer = (value) => {
            return isStringSet(value) ? reasonMap[value] : m.general.pleaseSelect;
        };

        return (
            <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.props.handleClose}
                TransitionComponent={DialogTransition}
                TransitionProps={{
                    onExiting: this.handleClose
                }}>

                <ResponsiveDialogHeader
                    title={m.swipes.denyReasonDialogTitle}
                    handleClose={this.props.handleClose}
                    showBackIcon={false}
                    fullScreen={fullScreen} />

                <DialogContent className={classes.contentRoot}>
                    <Typography paragraph variant="body1">
                        {m.swipes.denyReasonDialogMessage}
                    </Typography>
                    <DropDown
                        className={classes.dropdown}
                        value={this.state.denyReasonID || ''}
                        onChange={this.handleReasonChange}
                        displayEmpty={true}
                        renderValue={renderer}>
                        <MenuItem value="">{m.general.pleaseSelect}</MenuItem>
                        {this.props.denyReasons.map((reason, index) =>
                            <MenuItem key={index} value={reason.reasonID}>
                                {reason.reasonDescription}
                            </MenuItem>
                        )}
                    </DropDown>
                </DialogContent>
                <DialogActions>
                    {!fullScreen &&
                        <SecondaryDialogButton onClick={this.props.handleClose}>
                            {m.general.cancel}
                        </SecondaryDialogButton>
                    }
                    <PrimaryDialogButton onClick={this.onDeny} disabled={!this.canSave()}>
                        {m.swipes.deny}
                    </PrimaryDialogButton>
                </DialogActions>
            </Dialog>
        );
    }
}

const Media = withMediaQuery(theme => theme.breakpoints.down('lg'))(DenySwipeDialog);
const StyledDialog = withStyles(Media,styles);
export default StyledDialog;